import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Link,
  IconButton,
  Divider,
  Menu,
  MenuItem,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { Icon } from "@iconify/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXTwitter, faDiscord } from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  const [infoMenuAnchor, setInfoMenuAnchor] = useState(null);

  const handleInfoMenuOpen = (event) => {
    setInfoMenuAnchor(event.currentTarget);
  };

  const handleInfoMenuClose = () => {
    setInfoMenuAnchor(null);
  };

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: "rgb(40, 44, 52)",
        color: "white",
        mt: "auto",
        py: 3,
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          {/* Logo */}
          <Box
            component={RouterLink}
            to="/"
            sx={{ display: "flex", mb: { xs: 2, md: 0 } }}
          >
            <img
              src="/logo/logolarge.png"
              alt="TOG Logo"
              style={{ height: "40px" }}
            />
          </Box>

          {/* Navigation Links - Updated to match Navigation.jsx */}
          <Box
            sx={{
              display: "flex",
              gap: 3,
              justifyContent: "center",
              mb: { xs: 2, md: 0 },
            }}
          >
            <Link
              component={RouterLink}
              to="/"
              color="inherit"
              underline="none"
            >
              HOME
            </Link>
            <Link
              component={RouterLink}
              to="/events"
              color="inherit"
              underline="none"
            >
              EVENTS
            </Link>
            <Link
              component={RouterLink}
              to="/clips"
              color="inherit"
              underline="none"
            >
              CLIPS
            </Link>
            <Link
              component={RouterLink}
              to="/chat"
              color="inherit"
              underline="none"
            >
              CHAT
            </Link>
            {/* Info dropdown link */}
            <Link
              color="inherit"
              underline="none"
              onClick={handleInfoMenuOpen}
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              INFO{" "}
              <Icon icon="mdi:chevron-down" style={{ marginLeft: "4px" }} />
            </Link>
            {/* Info dropdown menu */}
            <Menu
              anchorEl={infoMenuAnchor}
              open={Boolean(infoMenuAnchor)}
              onClose={handleInfoMenuClose}
              MenuListProps={{
                "aria-labelledby": "info-button",
              }}
              sx={{
                "& .MuiPaper-root": {
                  backgroundColor: "rgb(40, 44, 52)",
                  color: "white",
                  borderRadius: "4px",
                  mt: 1,
                },
              }}
            >
              <MenuItem
                component={RouterLink}
                to="/faq"
                onClick={handleInfoMenuClose}
                sx={{
                  color: "white",
                  "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.1)" },
                }}
              >
                FAQ
              </MenuItem>
              <MenuItem
                component={RouterLink}
                to="/code-of-conduct"
                onClick={handleInfoMenuClose}
                sx={{
                  color: "white",
                  "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.1)" },
                }}
              >
                Code of Conduct
              </MenuItem>
              <MenuItem
                component={RouterLink}
                to="/ranks"
                onClick={handleInfoMenuClose}
                sx={{
                  color: "white",
                  "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.1)" },
                }}
              >
                Ranks
              </MenuItem>
              <MenuItem
                component={RouterLink}
                to="/policies"
                onClick={handleInfoMenuClose}
                sx={{
                  color: "white",
                  "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.1)" },
                }}
              >
                Terms & Policies
              </MenuItem>
            </Menu>
          </Box>
        </Box>

        <Divider sx={{ backgroundColor: "rgba(255, 255, 255, 0.1)", my: 2 }} />

        {/* Social Media Icons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            gap: 2,
            mb: 2,
          }}
        >
          <IconButton
            color="inherit"
            aria-label="Discord"
            component="a"
            href="https://discord.gg/togx"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon
              icon={faDiscord}
              style={{ width: "24px", height: "24px" }}
            />
          </IconButton>
          <IconButton
            color="inherit"
            aria-label="X (formerly Twitter)"
            component="a"
            href="https://x.com/TOG_Org"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon
              icon={faXTwitter}
              style={{ width: "24px", height: "24px" }}
            />
          </IconButton>
          <IconButton
            color="inherit"
            aria-label="Instagram"
            component="a"
            href="https://www.instagram.com/togx_org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon icon="mdi:instagram" width="24" height="24" />
          </IconButton>
          <IconButton
            color="inherit"
            aria-label="Twitch"
            component="a"
            href="https://www.twitch.tv/togxesports"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon icon="mdi:twitch" width="24" height="24" />
          </IconButton>
          <IconButton
            color="inherit"
            aria-label="YouTube"
            component="a"
            href="https://www.youtube.com/@togxesports"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Icon icon="mdi:youtube" width="24" height="24" />
          </IconButton>
        </Box>

        {/* Copyright */}
        <Box
          sx={{
            backgroundColor: "rgba(0, 0, 0, 0.749)",
            py: 1,
            textAlign: "center",
            borderRadius: 3,
          }}
        >
          <Typography variant="body2" color="#fff">
            Copyright © 2023 - {new Date().getFullYear()} The Order of Gaming.
            All rights reserved. Website designed by{" "}
            <Link
              href="https://www.cyberuk.me"
              target="_blank"
              rel="noopener"
              sx={{ textDecoration: "none", color: "#7D7D7D" }}
            >
              Cyber
            </Link>{" "}
            and TOG.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
